import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  width: 269px;
  display: flex;
  flex-direction: column;
  align-items: start;
  border-radius: 16px;
  z-index: 2;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
  margin-top: 1rem;
  scale: ${(props) => props?.scale || "1"};
  margin-bottom: ${(props) => props?.marginBottom || "0px"};

  @media screen and (min-height: 769px) {
    width: 359px;
  }
`;

export const ContainerColor = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 16px;
  background-color: #fff;
  overflow: hidden;
  padding: 16px;

  @media screen and (min-height: 769px) {
    row-gap: 16px;
  }
`;

export const ContainerInner = styled.div`
  height: max-content;
  display: flex;
  border-radius: 16px;
  align-items: start;
  flex-direction: column;
  cursor: pointer;
  gap: 10px;
  overflow: hidden;
  padding: 2px;
  z-index: 100;
`;

export const ContainerText = styled.div`
  display: flex;
  flex-direction: column;
  white-space: nowrap;
  margin-top: 8px;
  margin-left: 3px;
`;

export const Title = styled.span`
  color: ${(props) => props.color || "#1F2D3D"};
  font-size: ${(props) => props.fontSize || "11px"};
  line-height: ${(props) => props.lineHeight || "13px"};
  font-weight: ${(props) => props.fontWeight || 700};
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
  word-break: break-all;
  width: calc(98%);
  padding-bottom: 2px;
`;

export const LocationWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const LocationNameWrapper = styled.div`
  display: flex;
  @media screen and (min-height: 769px) {
    margin-top: 6px;
    margin-left: 4px;
    padding-bottom: 0;
  }
`;

export const ButtonCard = styled.button`
  min-width: 100%;
  height: 32px;
  font-weight: bold;
  font-size: 16px;
  align-self: center;
  color: ${(props) => props.color || "#6A7481"};
  border: 1px solid #1f2d3d;
  border-radius: 24px;
  padding: 8px, 16px, 8px, 16px;
  background-color: ${(props) =>
    props.backgroundColor || "rgba(106, 116, 129, 0)"};
  border-color: ${(props) => props.borderColor || "#6A7481"};

  @media screen and (max-height: 700px) {
    font-size: 12px;
  }

  @media screen and (min-height: 769px) {
    margin-top: 16px;
  }
`;

export const SwooshSVG = styled.img`
  position: absolute !important;
  top: 0 !important;
  right: 0 !important;
  z-index: 0 !important;
  object-fit: cover;
`;
